import { get } from "lodash";

const isProduction =
  (process.env.REACT_APP_NODE_ENV || "").toLowerCase() === "production";

const featureFlags = {
  // Reward-points/redemption management (Point History, Mission, Reward Catalog, Redemption
  // Settings/Report, etc.). Rolled out to production after sandbox validation, so enabled everywhere.
  rewardPointsCheckout: true,
  updateOrderStatus: !isProduction,

  newClaimPayoutFlow: true,
};

export function getFeatureFlag(key) {
  return get(featureFlags, key, false);
}
